import { MDBIcon, MDBModal } from "mdbreact";
import React from "react";
import { Shop } from "../../../containers/Shops";
import { handelExternalLinkClick } from "../../../utilities/WespoUtil";
import Description from "../../elements/description/Description";
import classes from "./ShopDescriptionModal.module.scss";
import { LineElement } from "../../elements/text-decoration/TextDecoration";

/**
 * 店舗詳細モーダルのプロパティ
 */
type ShopDescriptionModalProps = {
  /** モーダル展開状態 */
  isOpen: boolean;
  /** 店舗情報 */
  shop?: Shop;
  /** 注意文 */
  notices?: string[];
  /** モーダルを閉じるときの処理 */
  onCloseButtonClick: () => void;
};

/**
 * 店舗詳細モーダル
 * @param props 店舗詳細モーダルのプロパティ
 */
const ShopDescriptionModal: React.FC<ShopDescriptionModalProps> = (props) => {
  let url: string | undefined = undefined;
  let description: LineElement | undefined = undefined;

  if (props.shop?.basicInfo?.description?.startsWith("http")) {
    url = props.shop?.basicInfo?.description;
  } else {
    description = { text: props.shop?.basicInfo?.description };
  }

  return (
    <MDBModal isOpen={props.isOpen} toggle={() => {}} className={classes.modal}>
      <div className={classes.header} onClick={props.onCloseButtonClick}>
        <MDBIcon icon="angle-left" className="mr-2" />
        閉じる
      </div>

      {props.shop ? (
        <div className={classes.body}>
          <div className={classes.content}>
            <img
              className={`img-fluid ${classes.bannerImage}`}
              src={props.shop.basicInfo?.banner}
              alt={props.shop.name}
            ></img>
          </div>

          <div className={`px-3 ${classes.content}`}>
            <div className={classes.subContent}>
              {props.shop.basicInfo?.genre ? (
                <div className={classes.genre}>
                  {props.shop.basicInfo.genre}
                </div>
              ) : null}
              <div className={classes.shopName}>{props.shop.name}</div>
            </div>

            {description ? (
              <div className={classes.subContent}>
                <Description message={[description]} />
              </div>
            ) : null}
          </div>

          {url ? (
            <div className={`px-3 my-3 ${classes.externalLink}`}>
              <a
                href={url}
                onClick={(event) => handelExternalLinkClick(event, url || "")}
              >
                お店の詳細はこちら
              </a>
            </div>
          ) : null}

          {description ? (
            <>
              <div className={`px-3 ${classes.content}`}>
                <div className={classes.basicInfoTable}>
                  <div className={classes.tableTitle}>この店舗の基本情報</div>
                  <table className={classes.table}>
                    <tbody>
                      <tr>
                        <td className={classes.headerCell}>ジャンル</td>
                        <td>{props.shop.basicInfo?.genre || "--"}</td>
                      </tr>
                      <tr>
                        <td className={classes.headerCell}>営業時間</td>
                        <td>{props.shop.basicInfo?.businessHours || "--"}</td>
                      </tr>
                      <tr>
                        <td className={classes.headerCell}>予算</td>
                        <td>{props.shop.basicInfo?.budget || "--"}</td>
                      </tr>
                      <tr>
                        <td className={classes.headerCell}>電話番号</td>
                        <td>{props.shop.basicInfo?.tel || "--"}</td>
                      </tr>
                      <tr>
                        <td className={classes.headerCell}>その他</td>
                        <td>{props.shop.basicInfo?.others || "--"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {props.notices ? (
                <div className={`px-3 ${classes.content}`}>
                  <div className={classes.notices}>
                    {props.notices.map((n, idx) => {
                      return <div key={idx}>{n}</div>;
                    })}
                  </div>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      ) : null}
    </MDBModal>
  );
};

export default ShopDescriptionModal;
